import { FC, useState } from 'react';
import { cross } from '../../assets';

interface IOtpInputProps {
  headerTitle: string;
  email: string;
  onClose: () => void;
  onVerify: (
    otpValue: string,
    setIsVerifyingOtp: React.Dispatch<React.SetStateAction<boolean>>
  ) => Promise<void>;
}

const OtpInput: FC<IOtpInputProps> = ({
  headerTitle,
  email,
  onClose,
  onVerify,
}) => {
  const length = 6;
  const [otp, setOtp] = useState<string[]>(Array(length).fill(''));
  const [isVerifyingOtp, setIsVerifyingOtp] = useState<boolean>(false);

  const handleChange = (value: string, index: number) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value.length === 1 && index < length - 1) {
      document.getElementById(`otp-input-${index + 1}`)?.focus();
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`)?.focus();
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const otpValue = otp.join('');
    if (otpValue.length === length) {
      onVerify(otpValue, setIsVerifyingOtp);
    } else {
      alert('Please fill all the fields.');
    }
  };

  return (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md w-full max-w-[320px] sm:w-96 mx-auto relative">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-base sm:text-lg font-medium text-center">{headerTitle}</h2>
        <button onClick={onClose} className="text-black focus:outline-none">
          <img src={cross} alt="Close" className="w-5 h-5" />
        </button>
      </div>

      <p className="text-start mb-3 text-slate-500 text-xs sm:text-sm">
        Enter the verification code sent to
      </p>
      <p className="text-center mb-5 text-slate-600 font-medium text-sm sm:text-base break-all">{email}</p>

      <form onSubmit={handleSubmit}>
        <div className="flex justify-center mb-4 space-x-1 sm:space-x-2">
          {otp.map((_, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={otp[index]}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              maxLength={1}
              className="w-8 h-10 sm:w-10 sm:h-12 text-center text-lg border-2 border-slate-400 bg-transparent text-black rounded-md focus:outline-none focus:ring-2 focus:ring-[#6741c6]"
              required
            />
          ))}
        </div>
        <button 
          type="submit" 
          className="btn-primary w-full h-12 text-sm sm:text-base bg-[#6741c6] hover:bg-[#5536a5]"
          disabled={isVerifyingOtp}
        >
          {isVerifyingOtp ? 'Verifying...' : 'Verify'}
        </button>
      </form>

      <div className="mt-4 text-center">
        <button
          className="btn-text w-full hover:underline text-xs sm:text-sm text-[#6741c6]"
          disabled={isVerifyingOtp}
        >
          Resend verification code
        </button>
      </div>
    </div>
  );
};

export default OtpInput;